import { render, staticRenderFns } from "./XSelectPartidaPresupuestal.vue?vue&type=template&id=c21f853a&"
import script from "./XSelectPartidaPresupuestal.vue?vue&type=script&lang=js&"
export * from "./XSelectPartidaPresupuestal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports